'use client';

import {
  Footer,
  LdJSONSchemaScriptTag,
  Loader,
  PageNotFound,
  ProgressBar
} from 'components/atomic/atoms';
import { ToastContainer } from 'components/atomic/molecules';
import { HeaderOrganism } from 'components/atomic/organism';

const StandardLayout = ({
  children,
  headParameters = {},
  loading,
  pageDataFound = true,
  pageNotFound: { description, notFoundImage, title } = {},
  setShowToast,
  showHeader = true,
  showLoader = true,
  showToast = { message: '', show: false, status: false }
}) => {
  const {
    categoriesWithSubCategories,
    doNotShowWhatsApp,
    eventJourney,
    heading,
    ldJson,
    parentCategories,
    parentSlug,
    showCartView,
    showFooter,
    showHeaderEventList,
    showSearchIcon
  } = headParameters;

  const direction = 'ltr';

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {ldJson && <LdJSONSchemaScriptTag ldJson={ldJson} />}
      <ToastContainer {...{ showToast, setShowToast }} />
      {pageDataFound ? (
        <div className='flex flex-col justify-between h-screen'>
          <div dir={direction}>
            {showLoader && <ProgressBar />}
            {showHeader && (
              <HeaderOrganism
                {...{
                  categories: parentCategories,
                  categoriesWithSubCategories,
                  doNotShowWhatsApp,
                  eventJourney,
                  heading,
                  parentSlug,
                  showCartView,
                  showHeaderEventList,
                  showSearchIcon
                }}
              />
            )}
            <main>{children}</main>
          </div>
          {showFooter ? <Footer /> : ''}
          {
            // TODO: if showHeader is outside, showFooter should have been outside as well
          }
        </div>
      ) : (
        <PageNotFound
          {...{
            description,
            notFoundImage,
            title
          }}
        />
      )}
    </>
  );
};

export default StandardLayout;
